export default __webpack_public_path__ + "static/media/step-2-2.6916e99f.jpg";